<template>
  <div class="first-plus">
    <div class="banner">
      <swiper :img-list="bannerList" id="plus-swiper"></swiper>
    </div>
    <div
      class="first-plus-wrapper"
      :style="{ backgroundColor: bgc }"
      v-show="productList.length">
      <list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <product-list :sku-list="productList"></product-list>
      </list>
    </div>
    <FunctionalFloating />
  </div>
</template>

<script>
import { List } from 'vant'
import Swiper from '../../components/swiper'
import ProductList from '../../components/ProductDoubleEach'
import FunctionalFloating from '../../components/activitys/FunctionalFloating'
import api from '../../utils/api'
let flag = false
export default {
  name: 'firstPlus',
  components: {
    List,
    Swiper,
    FunctionalFloating,
    ProductList
  },
  data () {
    return {
      loading: false,
      finished: false,
      bannerList: [],
      productList: [],
      pageNum: 1,
      bgc: 'transparent'
    }
  },
  created () {
    this.$toast.loading({
      duration: 3000000,
      msg: '正在加载...'
    })
    this.getBannerList()
    this.getAcitityProductConfig()
    this.getBgcColor()
    // this.getActivityDetails(this.$route.query.cid)
  },
  methods: {
    onLoad () {
      // 异步更新数据
      if (flag) {
        return false
      }
      flag = true
      setTimeout(() => {
        // this.getProductList(++this.pageNum).then(() => {
        //   flag = false
        //   this.loading = false
        // })
      }, 500)
    },
    // async getActivityDetails (cid) {
    //   const res = await this.$axios.get(`api/act/info/${cid}`)
    //   console.log(res)
    // },
    async getBgcColor () {
      const data = await api.getLocationCodingHandler('firstplushome-0')
      if (data) {
        this.bgc = data[0].configer.coding
      }
    },
    async getBannerList () {
      const data = await api.getLocationCodingHandler('firstplushome-1')
      if (data) {
        this.bannerList = data
      }
    },
    async getAcitityProductConfig () {
      const data = await api.getLocationCodingHandler('firstplushome-2')
      if (data) {
        this.aid = data[0].configer.aid
        this.getProductList()
      }
    },
    async getProductList (pageNum) {
      // /${pageNum || 1}
      const res = await this.$axios.get(`api/act/goods/${this.aid}`)
      if (res.status === 200) {
        this.$toast.clear()
        const { code, data, msg } = res.data
        if (code === 0) {
          this.productList = [...this.productList, ...data]
          this.finished = true
        } else if (code === 9006) {
          if (this.pageNum === 1) {
            this.noData = true
          }
          this.finished = true
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.first-plus {
  .banner {
    width: 100%;
    height: 3.52rem;
    #plus-swiper{
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  &-wrapper {
    padding: 0 0.2rem 0.23rem;
    background-color: #F82E10;
  }
}
</style>
